import React from 'react';
import { SpacerRow, Text } from '@zg-rentals/multibrand-ui';

interface StatementEntryProps {
  text: string;
  emphasize: boolean | null;
  danger: boolean | null;
}

type Props = {
  statement: StatementEntryProps[];
};

const StatementEntry = (
  { text, emphasize, danger }: StatementEntryProps = { text: '', emphasize: null, danger: null },
) => (
  <Text inline emphasize={emphasize} danger={danger}>
    {text}
  </Text>
);

export const DashboardSubheading = ({ statement }: Props) => (
  <SpacerRow>
    {statement.map((props, index) => (
      <StatementEntry key={index} {...props} />
    ))}
  </SpacerRow>
);
